import { useState } from "react";
import InfoIcon from "@mui/icons-material/Info";
import { Popover, Typography, Box } from "@mui/material";

export default function InfoWithPopover({ reason }) {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        event.stopPropagation();
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;

    return (
        <div>
            <InfoIcon fontSize="small" sx={{ cursor: "pointer" }} onClick={handleClick} />
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                disableRestoreFocus
            >
                <Box p={2} maxWidth={250}>
                    <Typography fontSize={14}>{reason}</Typography>
                </Box>
            </Popover>
        </div>
    );
}
